<!-- can't put addRoleButton on the button as it re-renders when disabled state changes -->
<div #addRoleButton>
    <button id="add-role"
            adaptButtonIcon="fal fa-fw fa-user-plus"
            class="btn btn-sm btn-primary"
            [disabled]="!!newRole"
            (click)="addNewRole()">Create new role</button>
    <dx-popover [target]="addRoleButton"
                [visible]="editingRole"
                [hideOnOutsideClick]="false"
                (onHidden)="cancelNewRole().subscribe()">
        @if (newRole) {
            <div class="d-flex flex-column gap-2">
                <div>
                    <label for="new-role">Name</label>
                    <dx-text-box name="new-role"
                                 placeholder="Enter a name"
                                 (onInitialized)="focusTextBoxOnInitialise($event)"
                                 (onEnterKey)="saveNewRole().subscribe()"
                                 [readOnly]="savingRole"
                                 [(value)]="newRole.label"
                                 [adaptValidateEntity]="newRole"
                                 adaptValidateEntityProperty="label"
                                 data-test="new-role-name"></dx-text-box>
                </div>
                <div class="d-flex flex-row justify-content-evenly mt-auto">
                    <button adaptButton="add"
                            class="btn-sm flex-fill"
                            [disabled]="newRole.entityAspect.hasValidationErrors || savingRole"
                            [adaptBlockingClick]="saveNewRole"
                            [unsubscribeOnDestroy]="false"
                            data-test="save-role-button"></button>
                    <button adaptButton="cancel"
                            class="btn-sm flex-fill"
                            [disabled]="savingRole"
                            (click)="editingRole = false"></button>
                </div>
            </div>
        }
    </dx-popover>
</div>
